import Axios from "axios"
import { getItem } from "./LocalStorage"

const domain = "https://asia-southeast1-lockerja-e07a1.cloudfunctions.net"
// const domain = "http://127.0.0.1:5001/myprestasi-f6daa/asia-southeast1"

export const Get = (url, response, error, load) => {
  load(true)
  const token = getItem( 'AUTHORIZATION_TOKEN' )
  Axios.defaults.headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Authorization': `JWT ${ token }`
  }
  return Axios.get(`${domain}${url}`)
    .then((res) => {
      if(res.status!==200){
        error(res.data.message)
      }
      else
        response(res)
      load(false)
    })
    .catch((err) => {
      error( err ? err.message : 'Unexpected Error' )
      load(false)
    })
}

export const Post = (url, data, response, error, load) => {
  load(true)
  const token = getItem( 'AUTHORIZATION_TOKEN' )
  Axios.defaults.headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Authorization': `JWT ${ token }`
  }
  return Axios.post(`${domain}${url}`, data)
  .then((res) => {
    if(res.status!==200){
      error(res.data.message)
    }
    else
      response(res)
    load(false)
  })
  .catch((err) => {
    error( err ? err.message : 'Unexpected Error' )
    load(false)
  })
}

export const Delete = (url, response, error, load) => {
  load(true)
  const token = getItem( 'AUTHORIZATION_TOKEN' )
  Axios.defaults.headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Authorization': `JWT ${ token }`
  }
  return Axios.delete(`${domain}${url}`)
    .then((res) => {
      if(res.status!==200){
        error(res.data.message)
      }
      else
        response(res)
      load(false)
    })
    .catch((err) => {
      error( err ? err.message : 'Unexpected Error' )
      load(false)
    })
}